/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AgentV1NewPasswordsPostRequest model module.
 * @module model/AgentV1NewPasswordsPostRequest
 * @version 1.0.0
 */
class AgentV1NewPasswordsPostRequest {
    /**
     * Constructs a new <code>AgentV1NewPasswordsPostRequest</code>.
     * @alias module:model/AgentV1NewPasswordsPostRequest
     */
    constructor() { 
        
        AgentV1NewPasswordsPostRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AgentV1NewPasswordsPostRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentV1NewPasswordsPostRequest} obj Optional instance to populate.
     * @return {module:model/AgentV1NewPasswordsPostRequest} The populated <code>AgentV1NewPasswordsPostRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentV1NewPasswordsPostRequest();

            if (data.hasOwnProperty('password_reset_token')) {
                obj['password_reset_token'] = ApiClient.convertToType(data['password_reset_token'], 'String');
            }
            if (data.hasOwnProperty('password')) {
                obj['password'] = ApiClient.convertToType(data['password'], 'String');
            }
            if (data.hasOwnProperty('password_confirmation')) {
                obj['password_confirmation'] = ApiClient.convertToType(data['password_confirmation'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentV1NewPasswordsPostRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentV1NewPasswordsPostRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['password_reset_token'] && !(typeof data['password_reset_token'] === 'string' || data['password_reset_token'] instanceof String)) {
            throw new Error("Expected the field `password_reset_token` to be a primitive type in the JSON string but got " + data['password_reset_token']);
        }
        // ensure the json data is a string
        if (data['password'] && !(typeof data['password'] === 'string' || data['password'] instanceof String)) {
            throw new Error("Expected the field `password` to be a primitive type in the JSON string but got " + data['password']);
        }
        // ensure the json data is a string
        if (data['password_confirmation'] && !(typeof data['password_confirmation'] === 'string' || data['password_confirmation'] instanceof String)) {
            throw new Error("Expected the field `password_confirmation` to be a primitive type in the JSON string but got " + data['password_confirmation']);
        }

        return true;
    }


}



/**
 * @member {String} password_reset_token
 */
AgentV1NewPasswordsPostRequest.prototype['password_reset_token'] = undefined;

/**
 * @member {String} password
 */
AgentV1NewPasswordsPostRequest.prototype['password'] = undefined;

/**
 * @member {String} password_confirmation
 */
AgentV1NewPasswordsPostRequest.prototype['password_confirmation'] = undefined;






export default AgentV1NewPasswordsPostRequest;

